import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  plus20p0vtfmu0596 as plus,
  take3onnpy6q7ctcz as take,
  plus310ted5e4i90h as plus_0,
  getOrNull1go7ef9ldk0df as getOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  get_state389x218zizu8a as get_state,
  beginUse146s8dwmfk72s as beginUse,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_displayName274cn1h5q1fsg as get_displayName } from './annotationReaders.mjs';
import { serializer1cdzkc3mnhoc4 as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPathSerializer.mjs';
import {
  Companion_instancegwok6qx7et5m as Companion_instance,
  FormSelector1zdq40oqbcvms as FormSelector,
  FormRendererv0cfjgipxuxv as FormRenderer,
  get_kind27kjvyfnc9an8 as get_kind,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  size1hf9cj08wgoyn as size,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator2kgtccb0jt0mi as Generator,
} from './FormRenderer.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  DataClassPath3joljqmfaqhxf as DataClassPath,
  DataClassPathAccess21fi12r1lk4vq as DataClassPathAccess,
  DataClassPathNotNullyxwowc5mmyv5 as DataClassPathNotNull,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { lensByElementAssumingSetNeverManipulates1yt8q6qtxcnsa as lensByElementAssumingSetNeverManipulates } from '../../../../../reactive/com/lightningkite/reactive/lensing/LensByElementAssumingSetNeverManipulates.mjs';
import { lens27v59dqa1oc3r as lens_1 } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { nullElementzitp7se36veh as nullElement } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { toList383f556t1dixk as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  flatten3gnxaa49k1jva as flatten,
  withWritedlio9p0oewet as withWrite,
} from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { forEachUpdating2xo34s2yjc7ia as forEachUpdating } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_set__cb7isu($this, value, $completion) {
  if (!(value == null)) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.le0_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp$ret$0 = tmp;
    var tmp_0 = $this.le0_1.gah(plus(tmp$ret$0, value), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function PathPartsRenderer$form$lambda$o$addListener$lambda() {
  return Unit_instance;
}
function *_generator_invoke__zhh2q8($this, $this$withWrite, value, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.me0_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ne0_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = tmp_1.las();
  var tmp_2 = await_1(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$2 = tmp_2;
  var tmp_3 = take(tmp_0, tmp$ret$2);
  var tmp_4;
  if (value == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_4 = listOf(value);
  }
  var tmp1_elvis_lhs = tmp_4;
  var tmp_5;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.collections.listOf' call
    tmp_5 = emptyList();
  } else {
    tmp_5 = tmp1_elvis_lhs;
  }
  var tmp_6 = $this.me0_1.gah(plus_0(tmp_3, tmp_5), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  return Unit_instance;
}
function PathPartsRenderer$form$lambda$lambda(it) {
  return it.n4q();
}
var PathPartsRenderer$form$2$1Class;
function PathPartsRenderer$form$2$1() {
  if (PathPartsRenderer$form$2$1Class === VOID) {
    class $ {
      constructor($it, $properties) {
        this.ke0_1 = $it;
        this.le0_1 = $properties;
        this.je0_1 = null;
      }
      las() {
        return new (Constant())(_Constant___init__impl__v45mub(this.ke0_1.p1()));
      }
      f2() {
        return this.je0_1;
      }
      tah(listener) {
        return PathPartsRenderer$form$lambda$o$addListener$lambda;
      }
      oe0(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
      gah(value, $completion) {
        return this.oe0((value == null ? true : isInterface(value, SerializableProperty())) ? value : THROW_CCE(), $completion);
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    protoOf($).qah = get_state;
    protoOf($).iaj = beginUse;
    initMetadataForClass($, VOID, VOID, VOID, [ReactiveValue(), MutableReactive()], [1]);
    PathPartsRenderer$form$2$1Class = $;
  }
  return PathPartsRenderer$form$2$1Class;
}
function Select$_get_opacity_$ref_j2rs99(p0) {
  return () => p0.gb7();
}
function Select$_set_opacity_$ref_b7me2n(p0) {
  return (_this__u8e3s4) => {
    p0.eb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var PathPartsRenderer$form$lambda$lambda$slambdaClass;
function PathPartsRenderer$form$lambda$lambda$slambda() {
  if (PathPartsRenderer$form$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($properties, $it) {
        this.me0_1 = $properties;
        this.ne0_1 = $it;
      }
      pe0($this$withWrite, value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, value), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.pe0(tmp, (p2 == null ? true : isInterface(p2, SerializableProperty())) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    PathPartsRenderer$form$lambda$lambda$slambdaClass = $;
  }
  return PathPartsRenderer$form$lambda$lambda$slambdaClass;
}
function PathPartsRenderer$form$lambda$lambda$slambda_0($properties, $it) {
  var i = new (PathPartsRenderer$form$lambda$lambda$slambda())($properties, $it);
  var l = ($this$withWrite, value, $completion) => i.pe0($this$withWrite, value, $completion);
  l.$arity = 2;
  return l;
}
function PathPartsRenderer$form$lambda$lambda$lambda(it) {
  var tmp1_elvis_lhs = it == null ? null : get_displayName(it);
  return tmp1_elvis_lhs == null ? '+' : tmp1_elvis_lhs;
}
var PathPartsRendererClass;
function PathPartsRenderer() {
  if (PathPartsRendererClass === VOID) {
    class $ {
      constructor() {
        PathPartsRenderer_instance = this;
        this.qe0_1 = 'Path Parts';
        this.re0_1 = (new (DataClassPathSerializer())(serializer(Unit_instance))).c4b_1.h10();
      }
      k20() {
        return this.qe0_1;
      }
      f94() {
        return this.re0_1;
      }
      ldu(module_0, selector) {
        var tmp = selector.edu_1;
        var serializer = tmp instanceof DataClassPathSerializer() ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.mdu(module_0, this, tmp_1, VOID, VOID, ($this$FormRenderer, field, mutable) => {
          var tmp = PathPartsRenderer$form$lambda$lambda;
          var properties = mutable.tak(tmp, (it) => {
            var out = new (DataClassPathSelf())(serializer.b4b_1);
            var lastNullable = false;
            var _iterator__ex2g4s = it.m1();
            while (_iterator__ex2g4s.n1()) {
              var prop = _iterator__ex2g4s.o1();
              if (lastNullable) {
                var tmp = new (DataClassPathNotNull())(out);
                out = new (DataClassPathAccess())(tmp, isInterface(prop, SerializableProperty()) ? prop : THROW_CCE());
              } else {
                var tmp_0 = out instanceof DataClassPath() ? out : THROW_CCE();
                out = new (DataClassPathAccess())(tmp_0, isInterface(prop, SerializableProperty()) ? prop : THROW_CCE());
              }
            }
            return out;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.ebb(p, view);
          view.xbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(false);
          var tmp_0 = lensByElementAssumingSetNeverManipulates(properties);
          var tmp_1 = lens_1(tmp_0, (it) => plus(it, new (PathPartsRenderer$form$2$1())(it, properties)));
          forEachUpdating(view_0, tmp_1, VOID, ($this$forEachUpdating, it) => {
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp = $this$forEachUpdating.hbb(FieldSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.select' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (Select())($this$forEachUpdating.pc());
            var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
            $this$forEachUpdating.ebb(p, view);
            var options = remember(VOID, VOID, VOID, ($this$remember) => {
              var tmp0_safe_receiver = getOrNull($this$remember.baj(properties), $this$remember.baj($this$remember.baj(it).las()) - 1 | 0);
              var tmp;
              if (tmp0_safe_receiver == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.let' call
                var it_0 = tmp0_safe_receiver.j2j();
                var tmp0_elvis_lhs = nullElement(it_0);
                var tmp$ret$2 = tmp0_elvis_lhs == null ? it_0 : tmp0_elvis_lhs;
                var tmp0_elvis_lhs_0 = get_serializableProperties(tmp$ret$2);
                var tmp_0;
                if (tmp0_elvis_lhs_0 == null) {
                  // Inline function 'kotlin.arrayOf' call
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  tmp_0 = [];
                } else {
                  tmp_0 = tmp0_elvis_lhs_0;
                }
                tmp = tmp_0;
              }
              var tmp1_elvis_lhs = tmp;
              var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_serializableProperties(serializer.b4b_1) : tmp1_elvis_lhs;
              var tmp_1;
              if (tmp2_elvis_lhs == null) {
                // Inline function 'kotlin.arrayOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_1 = [];
              } else {
                tmp_1 = tmp2_elvis_lhs;
              }
              // Inline function 'kotlin.let' call
              var it_1 = toList(tmp_1);
              return plus_0(listOf(null), it_1);
            });
            var tmp_0 = KMutableProperty0();
            var tmp_1 = Select$_get_opacity_$ref_j2rs99(view);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('opacity', 0, tmp_0, tmp_1, Select$_set_opacity_$ref_b7me2n(view));
            reactiveScope(view, ($this$reactiveScope) => {
              var tmp$ret$13 = $this$reactiveScope.baj(options).p1() === 1 ? 0.0 : 1.0;
              this_0.set(tmp$ret$13);
              return Unit_instance;
            });
            var tmp_2 = flatten(it);
            var tmp_3 = withWrite(tmp_2, PathPartsRenderer$form$lambda$lambda$slambda_0(properties, it));
            view.mcf(tmp_3, options, PathPartsRenderer$form$lambda$lambda$lambda);
            $this$forEachUpdating.fbb(p, view);
            $this$forEachUpdating.jbb(tmp, view);
            return Unit_instance;
          });
          view.fbb(p_0, view_0);
          $this$FormRenderer.fbb(p, view);
          return view;
        });
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).idu = size;
    protoOf($).cdu = get_basePriority;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForObject($, 'PathPartsRenderer', VOID, VOID, [Generator()]);
    PathPartsRendererClass = $;
  }
  return PathPartsRendererClass;
}
var PathPartsRenderer_instance;
function PathPartsRenderer_getInstance() {
  if (PathPartsRenderer_instance === VOID)
    new (PathPartsRenderer())();
  return PathPartsRenderer_instance;
}
//region block: exports
export {
  PathPartsRenderer_getInstance as PathPartsRenderer_getInstance2ime2nh4qzqap,
};
//endregion

//# sourceMappingURL=PathPartsRenderer.mjs.map
